import React, { useState, useCallback } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import "../css/drag-drop.css";
import "../css/crs.css";
import "../css/navbar.css";

import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { TransformStepTypeElement, TransformStepElement, createStepObject } from './TransformSteps'
import { v4 as uuid } from "uuid";
import { BeaconSetSuggestions } from '../Components/BeaconDialogMap';
import { ToastError } from '../Components/ToastDisplay';
import { MdContentCut } from "react-icons/md";
import { FaRegPaste } from "react-icons/fa6";
import { FaRegCopy } from "react-icons/fa";
import { PiSelectionPlusThin } from "react-icons/pi";
import { PiSelectionSlashLight } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import { VscInsert } from "react-icons/vsc";
import { TbSwitch } from "react-icons/tb";

import { Tooltip } from 'react-tooltip';

import * as Constants from '../constants.js'
import * as THREE from 'three';

import { Logger } from 'aws-amplify';
const logger = new Logger('CRSTransformDialog');

const stepTypes = Array.from({ length: 7 }, (v, k) => ({
    id: "id:" + uuid(),
    Type: k,
    isTypeOnly: true
}));

//when dragging - show if it is about to be deleted or in the
//right place to drop - or static
function getListRowClassName(snapshot) {

    if (snapshot.isDragging) {
        if (!snapshot.draggingOver) {
            if (snapshot.isDropAnimating) {
                return " hideDropAnimation "
            }
            else {
                return " draggingItemToDelete ";
            }
        }
        else {
            return " transformStepTypeItemDragging ";
        }
    }
    return " transformStepTypeItem ";

}

function getDraggingOverStepListClassName(snapshot) {

    if (snapshot.isDraggingOver && !snapshot.draggingFromThisWith) {
        return " isDraggingOverStepList "
    }

    return "";
}

function getValidityClassName(listInValid) {

    return !listInValid ? "" : " steplist-glow-red ";

}


//transform step render
function StepItem(props) {

    return (

        props.item.isTypeOnly ?
            <TransformStepTypeElement className={props.snapshot.isDragging ? "transformStepTypeItemDragging" : "transformStepTypeItem"} transformStep={props.item} /> :
            <TransformStepElement className={getListRowClassName(props.snapshot)} transformStep={props.item} />
    );
}

//static row in the list
function ListRow(props) {

    const { index, item } = props;

    return (
        <Draggable draggableId={item.id} index={index} key={item.id}>
            {(provided, snapshot) =>
            (

                <div
                    // style={getStyle(provided, props.style, snapshot.isDragging)}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <StepItem item={item} snapshot={snapshot} />
                </div>

            )}
        </Draggable>
    );
}
// This method is needed for rendering clones of draggables, as they are being dragged about
const getRenderItem = (items, style) => (provided, snapshot, rubric) => {
    const item = items[rubric.source.index];
    return (
        <>
            <div
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={provided.innerRef}
            >
                <StepItem item={item} snapshot={snapshot} />
            </div>
        </>
    );
};

function StepList(props) {

    const { listInValid, items, selectItem } = props;

    return (
        <Droppable
            renderClone={getRenderItem(items)}
            droppableId="transformSteps"
        >
            {(provided, snapshot) => (
                <ul
                    ref={provided.innerRef}
                    className={"steplist" + getDraggingOverStepListClassName(snapshot) + getValidityClassName(listInValid)}
                >
                    {items.map((item, index) => {
                        return (
                            <li key={item.id} className="selectionContainer">
                                <input
                                    className="selectionCheckbox"
                                    id={item.id}
                                    type='checkbox'
                                    checked={item?.selected}
                                    onChange={(event) => {
                                        selectItem(index, event.target.checked);

                                    }}
                                />
                                <ListRow item={item} index={index} />
                            </li>
                        );
                    })}
                    {provided.placeholder}
                </ul>
            )}

        </Droppable>
    );

}


//################################################################################################
// render fn
//################################################################################################
export function CrsTransformDialog(props) {
    const [steps, setSteps] = useState([]);
    const [listInValid, setListInValid] = useState(false);
    const [uiDisabled, setUiDisabled] = useState(false);

    const [cutDisabled, setCutDisabled] = useState(false);
    const [copyDisabled, setCopyDisabled] = useState(false);
    const [insertDisabled, setInsertDisabled] = useState(false);
    const [deleteDisabled, setDeleteDisabled] = useState(false);
    const [invertDisabled, setInvertDisabled] = useState(false);
    const [pasteDisabled, setPasteDisabled] = useState(false);  
    const [noSelection, setNoSelection] = useState(true);

    //disable buttons depending on selection
    React.useEffect(() => {
        let haveSelected = false;
        let numberSelected = 0;
        let contiguousSelection = false;
        let wasContiguousSelection = false;
        let lastSelected = false;
        steps.forEach(element => {
            if (element.selected) {
                haveSelected = true;
                numberSelected++;

                if (!wasContiguousSelection) {
                    wasContiguousSelection = true;
                    contiguousSelection = true;
                }
                else if (contiguousSelection && !lastSelected) {
                    contiguousSelection = false;                    
                }

                
            }

            lastSelected = element.selected;
        });

        setNoSelection(numberSelected === 0);

        logger.info("contiguousSelection", contiguousSelection);

        setCutDisabled(!haveSelected || uiDisabled);
        setCopyDisabled(!haveSelected || uiDisabled);
        setDeleteDisabled(!haveSelected || uiDisabled);
        setInsertDisabled(!haveSelected || uiDisabled);
        setPasteDisabled((numberSelected > 0 && !contiguousSelection) || uiDisabled);
        setInvertDisabled(!contiguousSelection || uiDisabled);
        
    }, [steps, uiDisabled]);

    function selectItem(item, select) {
        let newSteps = JSON.parse(JSON.stringify(steps));
        newSteps[item].selected = select;
        setSteps(newSteps);
    }

    React.useEffect(() => {

        //copy steps
        //add ids for list reordereing
        if (props.show) {
            BeaconSetSuggestions(props.helpContext);
            let copiedSteps = JSON.parse(JSON.stringify(props.crsTransform.TransformSteps));
            copiedSteps.forEach(element => {
                element.id = "id:" + uuid();
                element.isInvalid = false;
            });
            setSteps(copiedSteps);
        }
        else {
            BeaconSetSuggestions(props.parentHelpContext);
            setSteps([]);
        }
    }, [props.crsTransform, props.helpContext, props.parentHelpContext, props.show])

    //clipboard shortcuts
    const handleKeyPress = useCallback((event) => {

        //ignore if the target is a text input
        if ((!event?.target?.type) || !event?.target?.type === "text") {
            if (event.key === "c" && (event.ctrlKey || event.metaKey)) {
                // Ctrl + C pressed
                onCopy();
            } else if (event.key === "x" && (event.ctrlKey || event.metaKey)) {
                // Ctrl + X pressed
                onCut();
            } else if (event.key === "v" && (event.ctrlKey || event.metaKey)) {
                // Ctrl + V pressed
                onPaste(false);
            } else if (event.key === "Insert" && (event.ctrlKey || event.metaKey)) {
                // Ctrl + Insert pressed
                onPaste(true);
            } else if (event.key === "Delete") {
                // Delete pressed
                onDelete();
            } else if (event.key === "a" && (event.ctrlKey || event.metaKey)) {
                // Ctrl + A pressed
                onSelectAll();
            } else if (event.key === "i" && (event.ctrlKey || event.metaKey)) {
                // Ctrl + I pressed
                onInvert();
            }
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [steps]);

    React.useEffect(() => {
        // attach the keyboard event listener
        window.addEventListener('keydown', handleKeyPress);

        // remove the event listener
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);


    function reorderSteps(startIndex, endIndex) {
        const reordered = Array.from(steps);
        const [removed] = reordered.splice(startIndex, 1);
        reordered.splice(endIndex, 0, removed);

        setSteps(reordered);
    }

    function insertIntoSteps(item, insertIndex) {

        const inserted = Array.from(steps);
        let newItem = createStepObject(item.Type);
        inserted.splice(insertIndex, 0, newItem);

        setSteps(inserted);
    }

    function removeFromSteps(index) {

        const removed = Array.from(steps);
        removed.splice(index, 1);

        setSteps(removed);
    }

    function isValid() {

        //are there any invlid transform steps to
        for (let index = 0; index < steps.length; index++) {
            const step = steps[index];
            if (step.isInvalid) {
                return false;
            }
        }

        return true;
    }


    function onDragEnd(result) {

        //source - transform steps in the crs transform
        if (result.source.droppableId === "transformSteps") {

            if (!result.destination || result.destination.droppableId === "transformStepTypes") {
                removeFromSteps(result.source.index);
                return;
            }
            else if (result.destination.droppableId === "transformSteps") {
                if (result.source.index !== result.destination.index) {
                    reorderSteps(result.source.index, result.destination.index);
                    return;
                }
            }
        }
        //source - transform step toolbox
        else if (result.source.droppableId === "transformStepTypes") {

            if (!result.destination) {
                return;
            }
            else if (result.destination.droppableId === "transformSteps") {
                insertIntoSteps(stepTypes[result.source.index], result.destination.index);
                return;
            }
        }

    }
    //just hide the dialog - cancel.
    function onClose() {
        props.setShow(false);
    }

    function onSave() {

        if (!isValid()) {
            setListInValid(true);
            setTimeout(() => { setListInValid(false) }, 200);
            return;
        };

        //copy new steps to the original conversion and pass up to the parent
        let copiedCrsTransform = JSON.parse(JSON.stringify(props.crsTransform));
        copiedCrsTransform.TransformSteps = steps;
        props.onSave(copiedCrsTransform, setUiDisabled);

    }






    //a fixed size list that copies items dragged from it
    function StepTypeList(props) {

        return (
            <Droppable
                renderClone={getRenderItem(props.items, props.className)}
                droppableId="transformStepTypes"
                isDropDisabled={true}
            >
                {(provided, snapshot) => (
                    <div
                        className={props.className}
                        ref={provided.innerRef}
                    >
                        {props.items.map((item, index) => {
                            const shouldRenderClone = item.id === snapshot.draggingFromThisWith;
                            return (
                                <React.Fragment key={item.id}>
                                    {shouldRenderClone ? (
                                        <TransformStepTypeElement className="react-beatiful-dnd-copy transformStepTypeItem" transformStep={item} isDragging={false} />
                                    ) : (
                                        <ListRow item={item} index={index} />
                                    )}
                                </React.Fragment>
                            );
                        })}
                        {provided.placeholder}
                    </div>
                )}

            </Droppable>
        );
    }

    function onCopy() {
        //copy the transform steps to the clipboard
        let copiedSteps = JSON.parse(JSON.stringify(steps));

        let stepsToCopy = [];
        copiedSteps.forEach(element => {
            delete element.isInvalid;
            delete element.id;

            if (element.selected) {
                delete element.selected;
                stepsToCopy.push(element);
            }
        });

        if (stepsToCopy.length === 0) {
            return;
        }


        //copy the transform steps to the clipboard
        navigator.clipboard.writeText(JSON.stringify(stepsToCopy, null, 2)).then(() => {
            logger.debug("copied to clipboard");
        }).catch((err) => {
            logger.error("Could not copy to clipboard", err);
            ToastError("Could not copy to clipboard", "Have you enabled the clipboard\npermission in the browser?");
        });

    }

    function onDelete() {
        cut(false);
    }

    function onCut() {
        cut(true);
    }

    function cut(copyToClipboard) {      //copy the transform steps to the clipboard
        let copiedSteps = JSON.parse(JSON.stringify(steps));

        let stepsToCopy = [];
        copiedSteps.forEach(element => {
            delete element.isInvalid;
            delete element.id;

            if (element.selected) {
                delete element.selected;
                stepsToCopy.push(element);
            }
        });

        if (stepsToCopy.length === 0) {
            return;
        }

        //remove the selected items from the list
        let stepsCopy = [];
        steps.forEach(element => {
            if (!element.selected) {
                stepsCopy.push(element);
            }
        });
        setSteps(stepsCopy);

        if (copyToClipboard) {
            //copy the transform steps to the clipboard
            navigator.clipboard.writeText(JSON.stringify(stepsToCopy, null, 2)).then(() => {

                logger.debug("copied to clipboard");
            }).catch((err) => {
                logger.error("Could not copy to clipboard", err);
                ToastError("Could not copy to clipboard", "Have you enabled the clipboard\npermission in the browser?");
            });
        }
    }

    function validateSteps(stepArray) {
        //validate the steps - check if they are valid

        for (let index = 0; index < stepArray.length; index++) {
            const step = stepArray[index];

            if (!("Type" in step)) {
                return false;
            }

            if (step.Type < 0 || step.Type > 6) {
                return false;
            }

            //matrix
            switch (Constants.stepTypeToInt(step.Type)) {
                case Constants.TransformStepType.Matrix:
                    if (!("Matrix" in step)) {
                        return false;
                    }

                    if (
                        !("m00" in step.Matrix) ||
                        !("m01" in step.Matrix) ||
                        !("m02" in step.Matrix) ||
                        !("m03" in step.Matrix) ||
                        !("m10" in step.Matrix) ||
                        !("m11" in step.Matrix) ||
                        !("m12" in step.Matrix) ||
                        !("m13" in step.Matrix) ||
                        !("m20" in step.Matrix) ||
                        !("m21" in step.Matrix) ||
                        !("m22" in step.Matrix) ||
                        !("m23" in step.Matrix) ||
                        !("m30" in step.Matrix) ||
                        !("m31" in step.Matrix) ||
                        !("m32" in step.Matrix) ||
                        !("m33" in step.Matrix)
                    ) {
                        return false;
                    }
                    break;
                case Constants.TransformStepType.RotateAboutX:
                case Constants.TransformStepType.RotateAboutY:
                case Constants.TransformStepType.RotateAboutZ:
                    if (!("Angle" in step)) {
                        return false;
                    }
                    break;
                case Constants.TransformStepType.Translate:
                    if (!("Translation" in step)) {
                        return false;
                    }
                    if (!("x" in step.Translation) || !("y" in step.Translation) || !("z" in step.Translation)) {
                        return false;
                    }
                    break;
                case Constants.TransformStepType.Scale:
                    if (!("Scale" in step)) {
                        return false;
                    }
                    if (!("x" in step.Scale) || !("y" in step.Scale) || !("z" in step.Scale)) {
                        return false;
                    }
                    break;
                case Constants.TransformStepType.EulerXYZRightHanded:
                    if (!("Rotation" in step)) {
                        return false;
                    }
                    if (!("x" in step.Rotation) || !("y" in step.Rotation) || !("z" in step.Rotation)) {
                        return false;
                    }
                    break;
                default:
                    return false;
            }

        }

        return true;
    }


    function invertMatrix(matrix) {

        let m = new THREE.Matrix4();
        m.set(
            matrix.m00, matrix.m01, matrix.m02, matrix.m03,
            matrix.m10, matrix.m11, matrix.m12, matrix.m13,
            matrix.m20, matrix.m21, matrix.m22, matrix.m23,
            matrix.m30, matrix.m31, matrix.m32, matrix.m33
        );

        m.invert();
        m.transpose();
        let invertedMatrix = {
            m00: m.elements[0],
            m01: m.elements[1],
            m02: m.elements[2],
            m03: m.elements[3],
            m10: m.elements[4],
            m11: m.elements[5],
            m12: m.elements[6],
            m13: m.elements[7],
            m20: m.elements[8],
            m21: m.elements[9],
            m22: m.elements[10],
            m23: m.elements[11],
            m30: m.elements[12],
            m31: m.elements[13],
            m32: m.elements[14],
            m33: m.elements[15]
        };
        return invertedMatrix;

    }

    function getNumberOfValuesInStep(step) {
        switch (Constants.stepTypeToInt(step.Type)) {
            case Constants.TransformStepType.Matrix:
                return 16;
            case Constants.TransformStepType.RotateAboutX:
            case Constants.TransformStepType.RotateAboutY:
            case Constants.TransformStepType.RotateAboutZ:
                return 1;
            case Constants.TransformStepType.Translate:
            case Constants.TransformStepType.Scale:
            case Constants.TransformStepType.EulerXYZRightHanded:
                return 3;
            default:
                return 0;
        }
    }

    function updateStepWithValues(step, values) {
        switch (Constants.stepTypeToInt(step.Type)) {
            case Constants.TransformStepType.Matrix:
                step.Matrix = {
                    m00: values[0],
                    m01: values[1],
                    m02: values[2],
                    m03: values[3],
                    m10: values[4],
                    m11: values[5],
                    m12: values[6],
                    m13: values[7],
                    m20: values[8],
                    m21: values[9],
                    m22: values[10],
                    m23: values[11],
                    m30: values[12],
                    m31: values[13],
                    m32: values[14],
                    m33: values[15]
                };
                break;
            case Constants.TransformStepType.RotateAboutX:
            case Constants.TransformStepType.RotateAboutY:
            case Constants.TransformStepType.RotateAboutZ:
                step.Angle = values[0];
                break;
            case Constants.TransformStepType.Translate:
                step.Translation = {
                    x: values[0],
                    y: values[1],
                    z: values[2]
                };
                break;
            case Constants.TransformStepType.Scale:
                step.Scale = {
                    x: values[0],
                    y: values[1],
                    z: values[2]
                };
                break;
            case Constants.TransformStepType.EulerXYZRightHanded:
                step.Rotation = {
                    x: values[0],
                    y: values[1],
                    z: values[2]
                };
                break;
            default:
                break;
        }
    }

    function getFirstSelectedStep() {
        let selectedStep = null;
        steps.forEach(element => {
            if (element.selected && !selectedStep) {
                selectedStep = element;
            }
        }
        );
        return selectedStep;
    }

    function onPaste(insert, stepId) {

        let haveCopied = false;
        //paste the transform steps from the clipboard
        navigator.clipboard.readText().then((text) => {

            logger.debug("## Pasted text from clipboard", text);
            haveCopied = true;

            let pastedSteps = null;
            try {
                pastedSteps = JSON.parse(text);
            }
            catch (e) {
                pastedSteps = null;
            }
            logger.debug("JSON data from clipboard", pastedSteps);

            if (pastedSteps && Array.isArray(pastedSteps) && validateSteps(pastedSteps)) {

                logger.debug("Pasted data is a valid set of transform steps", pastedSteps);
                let stepsCopy = [];
                let itemsCopied = false;
                steps.forEach(element => {
                    if (!element.selected) {
                        stepsCopy.push(element);
                    }
                    else {
                        //paste all items as we have found the first selected item
                        if (!itemsCopied) {
                            itemsCopied = true;
                            pastedSteps.forEach(element => {
                                element.selected = true;
                                element.id = "id:" + uuid();
                                element.isInvalid = false;
                                stepsCopy.push(element);
                            });
                        }
                        //if inserting we don't replace the selection
                        if (insert) {
                            element.selected = false;
                            stepsCopy.push(element);
                        }
                    }
                });

                //if items not yet copied - append to the end
                if (!itemsCopied) {
                    itemsCopied = true;
                    pastedSteps.forEach(element => {
                        element.id = "id:" + uuid();
                        element.isInvalid = false;
                        element.selected = true;
                        stepsCopy.push(element);
                    });
                }

                setSteps(stepsCopy);
            }
            else {

                logger.debug("Pasted data is not a valid set of transform steps - trying as numbers", text);

                //maybe we have a list of numbers - in which case have we got a step selected to paste into?
                const selectedStep = getFirstSelectedStep();

                // Extract array of floating point numbers from a string delimited by any non-number characters
                let numberList = text.match(/-?\d*\.?\d+(?:[eE][-+]?\d+)?/g)?.map(Number) || [];

                if (!selectedStep) {
                    ToastError("Error pasting from the clipboard", "No step selected for paste");
                }
                else if (Array.isArray(numberList) && numberList.length > 0 && numberList.every(num => typeof num === 'number')) {

                    if (numberList.length === getNumberOfValuesInStep(selectedStep)) {
                        //copy steps
                        let stepsCopy = JSON.parse(JSON.stringify(steps));

                        //find the selected step and update it
                        for (let iStep = 0; iStep < stepsCopy.length; iStep++) {
                            if (stepsCopy[iStep]?.selected) {
                                logger.debug("Pasting values into step", stepsCopy[iStep], numberList);
                                //update the step with the pasted values
                                updateStepWithValues(stepsCopy[iStep], numberList);
                                setSteps(stepsCopy);
                                break;
                            }
                        }

                    }
                    else {
                        ToastError("Error pasting from the clipboard",
                            "Wrong number of values for the selected transform step\n Expected " +
                            getNumberOfValuesInStep(selectedStep) + " but there were " + numberList.length + " values.");
                    }

                }
                else {

                    logger.error("Error pasting from the clipboard", pastedSteps);
                    ToastError("Error pasting from the clipboard", "Badly formed data.\nHave you copied from the correct source?");
                }
            }
        }).catch((err) => {
            logger.error("Error pasting from the clipboard", err);
            if (haveCopied) {
                ToastError("Error pasting from the clipboard.", "Badly formed data.\nHave you copied from the correct source?");
            }
            else {
                ToastError("Error pasting from the clipboard.", "Have you enabled the clipboard\npermission in the browser?");
            }
        });
    }


    function onInvert() {
        let copiedSteps = JSON.parse(JSON.stringify(steps));

        //only allow contiguous selected items to be inverted
        let lastSelected = -1;
        let stepsToInvert = [];
        for (let iStep = 0; iStep < copiedSteps.length; iStep++) {
            const element = copiedSteps[iStep];

            delete element.isInvalid;
            delete element.id;

            if (element.selected) {
                //check for contiguousness
                if (lastSelected === -1) {
                    lastSelected = iStep;
                }
                else if (iStep !== lastSelected + 1) {
                    //not contiguous - so we need to break the loop
                    ToastError("Error inverting transform steps", "Selected items are not contiguous.\nPlease select a contiguous range of items to invert.");
                    return;
                }
                else {
                    lastSelected = iStep;
                }

                delete element.selected;
                stepsToInvert.push(element);
            }
        }

        stepsToInvert.reverse();

        stepsToInvert.forEach(element => {
            element.id = "id:" + uuid();
            element.isInvalid = false;
            element.selected = true;

            //invert the transform step
            switch (element.Type) {
                case Constants.TransformStepType.Matrix:
                    element.Matrix = invertMatrix(element.Matrix);
                    break;
                case Constants.TransformStepType.RotateAboutX:
                    element.Angle = -element.Angle;
                    break;
                case Constants.TransformStepType.RotateAboutY:
                    element.Angle = -element.Angle;
                    break;
                case Constants.TransformStepType.RotateAboutZ:
                    element.Angle = -element.Angle;
                    break;
                case Constants.TransformStepType.Translate:
                    element.Translation.x = -element.Translation.x;
                    element.Translation.y = -element.Translation.y;
                    element.Translation.z = -element.Translation.z;
                    break;
                case Constants.TransformStepType.Scale:
                    element.Scale.x = 1 / element.Scale.x;
                    element.Scale.y = 1 / element.Scale.y;
                    element.Scale.z = 1 / element.Scale.z;
                    break;
                case Constants.TransformStepType.EulerXYZRightHanded:
                    element.Rotation.x = -element.Rotation.x;
                    element.Rotation.y = -element.Rotation.y;
                    element.Rotation.z = -element.Rotation.z;
                    break;
                default:
                    break;
            }
        });

        let stepsCopy = [];
        let itemsCopied = false;
        steps.forEach(element => {
            if (!element.selected) {
                stepsCopy.push(element);
            }
            else {
                //insert all items to replace first selected item found
                if (!itemsCopied) {
                    itemsCopied = true;
                    stepsToInvert.forEach(element => {
                        stepsCopy.push(element);
                    });
                }
            }
        });

        //if items not yet inserted - append to the end
        if (!itemsCopied) {
            itemsCopied = true;
            stepsToInvert.forEach(element => {
                stepsCopy.push(element);
            });
        }

        setSteps(stepsCopy);
    }

    function onSelectAll() {
        let newSteps = JSON.parse(JSON.stringify(steps));

        //select all items in the list
        newSteps.forEach(element => {
            element.selected = true;
        });
        setSteps(newSteps);
    }

    function onSelectNone() {
        let newSteps = JSON.parse(JSON.stringify(steps));

        //deselect all items in the list
        newSteps.forEach(element => {
            element.selected = false;
        });
        setSteps(newSteps);
    }


    return (
        <Modal
            show={props.show}
            onHide={onClose}
            backdrop="static"
            keyboard={true}
            centered
            size="lg"
            dialogClassName="modal-850w"
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.dialogTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Container >
                        <Row>
                            <div className="ps-4 pb-4">Drag new transforms onto the list to add them. Drag them away to remove.</div>
                        </Row>

                        <Row>
                            <Col>
                                <StepList items={steps} listInValid={listInValid} selectItem={selectItem} />
                                <div className="button-row">
                                    <div data-tooltip-id="nav-tooltip" data-tooltip-content="Cut">
                                        <Button disabled={ cutDisabled} className="mt-1 " onClick={onCut}><MdContentCut /></Button>
                                    </div>
                                    <div data-tooltip-id="nav-tooltip" data-tooltip-content="Copy">
                                        <Button disabled={copyDisabled} className="mt-1 ms-2" onClick={onCopy}><FaRegCopy /></Button>
                                    </div>
                                    <div data-tooltip-id="nav-tooltip" data-tooltip-content={noSelection ? "Paste (append to list)" : "Paste (Replace selection)"}>
                                        <Button disabled={pasteDisabled} className="mt-1 ms-2" onClick={() => onPaste(false)}><FaRegPaste /></Button>
                                    </div>
                                    <div data-tooltip-id="nav-tooltip" data-tooltip-content="Paste (Insert before selection)">
                                        <Button disabled={insertDisabled} className="mt-1 ms-2" onClick={() => onPaste(true)}><VscInsert /></Button>
                                    </div>
                                    <div data-tooltip-id="nav-tooltip" data-tooltip-content="Delete selected">
                                        <Button disabled={deleteDisabled} className="mt-1 ms-2" onClick={onDelete}><RiDeleteBinLine /></Button>
                                    </div>
                                    <div data-tooltip-id="nav-tooltip" data-tooltip-content="Select All">
                                        <Button className="mt-1 ms-2" onClick={onSelectAll}><PiSelectionPlusThin /></Button>
                                    </div>
                                    <div data-tooltip-id="nav-tooltip" data-tooltip-content="Select None">
                                        <Button className="mt-1 ms-2" onClick={onSelectNone}><PiSelectionSlashLight /></Button>
                                    </div>
                                    <div data-tooltip-id="nav-tooltip" data-tooltip-content="Invert selected">
                                        <Button disabled={invertDisabled} className="mt-1 ms-2" onClick={onInvert}><TbSwitch /></Button>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <StepTypeList items={stepTypes} className="stepTypeList" />
                            </Col>
                        </Row>
                    </Container>
                </DragDropContext>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={uiDisabled} variant="primary" onClick={onSave}>Save</Button>
                <Button disabled={uiDisabled} variant="secondary" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
            <Tooltip className="tooltip-style" id="nav-tooltip" place="bottom" />
        </Modal>

    );
}

export default CrsTransformDialog;
